import React from 'react'

const BannerLandingAbout = (props) => (
    <section id="banner" className="style2">
        <div className="inner">
            <header className="major">
                <h1>The Arrangement</h1>
            </header>
            <div className="content">
                <h2>Who created it, and how it was run</h2>
            </div>
        </div>
    </section>
)

export default BannerLandingAbout



// WEBPACK FOOTER //
// ./src/components/BannerLandingAbout.js